export default __webpack_public_path__ + "static/retail-parking-customer-feedback-1747ac5172f11694ebbb7c35dacf092b.jpg";